// Identifies this browser tab for the lifetime of the page, so a tab can skip
// its own broadcast echo. The user id can't do that job — two tabs of the same
// user share it. Module scope rather than sessionStorage, which a duplicated
// tab would inherit from the tab it was cloned from.
const CLIENT_TAB_ID = `tab-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;

export default CLIENT_TAB_ID;
